import styled from 'styled-components';
import { C as Container } from './index.styled2.js';
import { I as Input } from './index.styled7.js';
import { W as Wrapper } from './index.styled3.js';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import { jsx } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var IndeterminateMark$1 = function IndeterminateMark(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/jsx("svg", {
    className: "gz-checkbox__wrapper_indeterminate-mark ".concat(className),
    viewBox: "0 0 14 14",
    role: "presentation",
    children: /*#__PURE__*/jsx("g", {
      children: /*#__PURE__*/jsx("rect", {
        height: "3",
        width: "14",
        x: "0",
        y: "5.5"
      })
    })
  });
};

IndeterminateMark$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.')
};
IndeterminateMark$1.defaultProps = {
  className: ''
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var IndeterminateMark = styled(IndeterminateMark$1).withConfig({
  componentId: "gz-checkbox-1673535246793__sc-1bka2j2-0"
})(["display:inline-block;flex-shrink:0;transform:scale(0.5);vertical-align:middle;width:100%;g{rect{fill:#fff;fill-opacity:0;transition:fill-opacity 240ms ease 0s,fill 240ms ease 0s;", ":hover > ", ":not(:disabled):not([checked]) + ", " &{fill:#b6b6b6;fill-opacity:1;}", "[checked] + ", " &{fill:#fff;fill-opacity:1;}}}"], Container, Input, Wrapper, Input, Wrapper);

export { IndeterminateMark as I };
